import { KostDataImportProcessData } from '@bindoc-projects/kost-data-import-lib/logic';
import {
  AysFabCreationStrategy,
  AysVirtualClinicP21ImportFabSelectionStrategy,
} from '@bindoc-projects/virtual-clinic-domain-lib';
import { BdState } from '@bindoc-projects/geographic-domain-lib';
import { AysDrgBaseRate } from '@bindoc-projects/code-domain-lib';

export interface KostDataInputDe {
  ICD?: string[][];
  OPS?: string[][];
  FALL: string[][];
  ENTGELTE: string[][];
  FAB: string[][];
  KOSTEN: string[][];
}

export interface KostDataImportProcessDataDe extends KostDataImportProcessData {
  parameters: {
    data: {
      fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;
      fabCreationStrategy: AysFabCreationStrategy;
      state: BdState;
      baseRates: { [year: string]: number };
    };
    anonymization: {
      salt: string;
      p21Case: {
        postalCode: boolean;
        randomizeInternMark: boolean;
      };
    };
  };
  dependencies: {
    postalCodeAdministrativeDistrictIdMap: { [postalCode: string]: number };
    drgBaseRates: { [year: string]: AysDrgBaseRate[] };
  };
  data: {
    input: File;
    output: {
      errors?: string[];
      transformed: Blob;
      additionalInformation: {
        fabPlusDetected: boolean;
      };
      additionalArtifacts: { content: File | Blob; displayName: string }[];
    };
  };
}

export const KOST_DATA_IMPORT_PROCESS_DATA_DE_DEFAULT: KostDataImportProcessDataDe =
  {
    virtualClinicId: null,
    acceptedTermsAndConditions: false,
    parameters: {
      data: {
        fabCreationStrategy: 'DEFAULT_301',
        fabSelectionStrategy: 'LAST_FAB',
        state: null,
        baseRates: null,
      },
      anonymization: {
        salt: null,
        p21Case: {
          postalCode: true,
          randomizeInternMark: false,
        },
      },
    },
    dependencies: {
      drgBaseRates: null,
      postalCodeAdministrativeDistrictIdMap: null,
    },
    data: {
      input: null,
      output: null,
    },
  };
